/* Birthday Sale product modal: the Modular Planner insert-detail copy, keyed by insert, matched by variantIds.
   Ported verbatim from the prototype's components/insert-details-data.js (copied from the live Modular Planner PDP on
   2026-10-14: variant metafields custom.modal_tagline / modal_inside / modal_best_for and the how-to steps).
   TODO (after the sale): read these from the variant metafields in Liquid (the planner PDP section already does) and drop
   this file, so the planner page and the builder can never disagree.
   The yearly set is the current one only (2027 Set, copy from its variant metafields on 2026-10-18; the 2026 Set is
   discontinued). It has no how-to steps until its custom.explainer metafield is filled, as on the planner page. Each new
   year: replace this entry with the new set's copy and variant id.
   Read by BDSProductModal.insert() in assets/mds-product-modal.js. */
window.BDS_INSERT_DETAILS = window.BDS_INSERT_DETAILS || {
  "goal-setting": {
    "title": "Goal Setting",
    "line": "Set goals, map the steps and review your progress.",
    "included": [
      "A5 - 100GSM Dutch White Paper",
      "60 pages (Track up to 60 goals)",
      "Track objectives and milestones",
      "Review progress"
    ],
    "bestFor": [
      "Turning goals into actionable steps and reviewing progress regularly."
    ],
    "howTo": [
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Goals1.jpg?v=1767581913&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Goals1.jpg?v=1767581913&width=2048",
        "title": "Step 1: Define",
        "lead": "Write down your goal, your why, and how you'll achieve it.",
        "body": "Getting clear on your motivation and action steps makes your goal concrete and actionable rather than vague."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Goals2.jpg?v=1767581913&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Goals2.jpg?v=1767581913&width=2048",
        "title": "Step 2: Visualize",
        "lead": "Describe what success looks like and how you'll reward yourself.",
        "body": "Defining tangible outcomes keeps you motivated and helps you recognize when you've actually achieved your goal."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Goals3.jpg?v=1767581913&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Goals3.jpg?v=1767581913&width=2048",
        "title": "Step 3: Anticipate",
        "lead": "Identify potential challenges and plan how you'll overcome them.",
        "body": "Thinking ahead about obstacles prevents them from derailing your progress when they inevitably arise."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Goals4.jpg?v=1767581913&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Goals4.jpg?v=1767581913&width=2048",
        "title": "Step 4: Reflect",
        "lead": "Use the memo section to capture detailed notes, context, and decisions.",
        "body": "Regular reflection helps you celebrate wins, learn from setbacks, and stay connected to your goal over time."
      }
    ],
    "howToPages": "60 Pages",
    "pages": "60 Pages",
    "images": [
      "https://shop.minimaldesksetups.com/cdn/shop/files/GoalsFull.jpg?v=1767581913&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Goals1.jpg?v=1767581913&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Goals2.jpg?v=1767581913&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Goals3.jpg?v=1767581913&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Goals4.jpg?v=1767581913&width=2048"
    ],
    "preview": "https://shop.minimaldesksetups.com/cdn/shop/files/GoalsFull.jpg?v=1767581913&width=700",
    "zoom": "https://shop.minimaldesksetups.com/cdn/shop/files/GoalsFull.jpg?v=1767581913&width=2048",
    "isNew": true,
    "priceCentsAU": 1399,
    "variantTitleMatch": "Goal Setting (",
    "variantIds": [
      49882481754305
    ],
    "catalogTitle": "Goal Setting (60 Pages)"
  },
  "focus": {
    "title": "Focus",
    "line": "Prioritize tasks based on urgency and importance (Eisenhower Matrix).",
    "included": [
      "A5 - 100GSM Dutch White Paper",
      "60 pages",
      "Group all your tasks into 4 categories."
    ],
    "bestFor": [
      "Anyone who has a lot of tasks and doesn't know where to start."
    ],
    "howTo": [
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Focus1.jpg?v=1767582088&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Focus1.jpg?v=1767582088&width=2048",
        "title": "Step 1: Prioritize",
        "lead": "Sort your tasks into the four quadrants based on urgency and importance.",
        "body": "This follows the Eisenhower Matrix. Do First, Do Later, Delegate, and Don't Do. It helps you focus on what truly matters."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Focus2.jpg?v=1767582087&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Focus2.jpg?v=1767582087&width=2048",
        "title": "Step 2: Execute",
        "lead": "Work through your \"Do First\" tasks before moving to anything else.",
        "body": "By tackling high-priority items when your energy is highest, you prevent urgent tasks from derailing your day and ensure critical work gets done."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Focus3.jpg?v=1767582088&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Focus3.jpg?v=1767582088&width=2048",
        "title": "Step 3: Capture",
        "lead": "Use the memo section to brain-dump notes or ideas as they arise.",
        "body": "This keeps scattered thoughts organized and out of your head, so you can reference them later without breaking focus on your current task."
      }
    ],
    "howToPages": "60 Pages",
    "pages": "60 Pages",
    "images": [
      "https://shop.minimaldesksetups.com/cdn/shop/files/FocusFull.jpg?v=1767582088&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Focus1.jpg?v=1767582088&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Focus2.jpg?v=1767582087&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Focus3.jpg?v=1767582088&width=2048"
    ],
    "preview": "https://shop.minimaldesksetups.com/cdn/shop/files/FocusFull.jpg?v=1767582088&width=700",
    "zoom": "https://shop.minimaldesksetups.com/cdn/shop/files/FocusFull.jpg?v=1767582088&width=2048",
    "isNew": true,
    "priceCentsAU": 1399,
    "variantTitleMatch": "Focus (",
    "variantIds": [
      49882445578433
    ],
    "catalogTitle": "Focus (60 Pages)"
  },
  "meeting-notes": {
    "title": "Meeting Notes",
    "line": "Capture every meeting with attendees, agenda and clear follow-up actions.",
    "included": [
      "A5 - 100GSM Dutch White Paper",
      "60 pages",
      "Structured meeting pages and a notes page",
      "Attendees, agenda and actions"
    ],
    "bestFor": [
      "Anyone who wants to keep day to day meetings and have clear outcomes and actions."
    ],
    "howTo": [
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Meeting1.jpg?v=1767582173&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Meeting1.jpg?v=1767582173&width=2048",
        "title": "Step 1: Set",
        "lead": "Fill in the date, meeting purpose, and attendees at the top.",
        "body": "This establishes context so anyone reviewing the notes later knows exactly what the meeting was about and who was there."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Meeting2.jpg?v=1767582173&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Meeting2.jpg?v=1767582173&width=2048",
        "title": "Step 2: Discuss",
        "lead": "List your key discussion points and check them off as you work through each topic.",
        "body": "This keeps the meeting on track and ensures nothing important gets missed."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Meeting3.jpg?v=1767582173&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Meeting3.jpg?v=1767582173&width=2048",
        "title": "Step 3: Assign",
        "lead": "Capture action items with due dates and owners in the actions table.",
        "body": "Clear accountability ensures tasks don't fall through the cracks after the meeting ends."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Meeting4.jpg?v=1767582173&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Meeting4.jpg?v=1767582173&width=2048",
        "title": "Step 4: Expand",
        "lead": "Use the memo section to capture detailed notes, context, and decisions.",
        "body": "This gives you space for the full picture while keeping the left side clean and scannable."
      }
    ],
    "howToPages": "60 Pages",
    "pages": "60 Pages",
    "images": [
      "https://shop.minimaldesksetups.com/cdn/shop/files/MeetingFull.jpg?v=1767582173&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Meeting1.jpg?v=1767582173&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Meeting2.jpg?v=1767582173&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Meeting3.jpg?v=1767582173&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Meeting4.jpg?v=1767582173&width=2048"
    ],
    "preview": "https://shop.minimaldesksetups.com/cdn/shop/files/MeetingFull.jpg?v=1767582173&width=700",
    "zoom": "https://shop.minimaldesksetups.com/cdn/shop/files/MeetingFull.jpg?v=1767582173&width=2048",
    "isNew": true,
    "priceCentsAU": 1399,
    "variantTitleMatch": "Meeting Notes (",
    "variantIds": [
      49882475233473
    ],
    "catalogTitle": "Meeting Notes (60 Pages)"
  },
  "wellness-tracker": {
    "title": "Wellness Tracker",
    "line": "Track what matters in your life including moods, thoughts and feelings.",
    "included": [
      "A5 - 100GSM Dutch White Paper",
      "60 Pages",
      "Track mood, rituals and thoughts",
      "Reflect on the 8 key aspects of your life with the wheel of life"
    ],
    "bestFor": [
      "Anyone who wants to reflect and understand how they feel."
    ],
    "howTo": [
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Wellness1.jpg?v=1767582878&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Wellness1.jpg?v=1767582878&width=2048",
        "title": "Step 1: Check-in",
        "lead": "Start with an affirmation and check off how you're feeling emotionally and physically.",
        "body": "This builds self-awareness by helping you notice patterns in your mood and energy over time."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Wellness2.jpg?v=1767582878&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Wellness2.jpg?v=1767582878&width=2048",
        "title": "Step 2: Reflect",
        "lead": "Write down why you feel the way you do today.",
        "body": "Understanding the cause behind your feelings helps you make better choices for your wellbeing."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Wellness3.jpg?v=1767582879&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Wellness3.jpg?v=1767582879&width=2048",
        "title": "Step 3: Ritualize",
        "lead": "Track your morning and evening rituals, and note three things you're grateful for.",
        "body": "Consistent habits and gratitude practice are proven to improve mental and physical health."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Wellness4.jpg?v=1767582879&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Wellness4.jpg?v=1767582879&width=2048",
        "title": "Step 4: Balance",
        "lead": "Rate each area on the Wheel of Life and choose one to improve.",
        "body": "This visual snapshot reveals which parts of your life need attention, turning reflection into action."
      }
    ],
    "howToPages": "60 Pages",
    "pages": "60 Pages",
    "images": [
      "https://shop.minimaldesksetups.com/cdn/shop/files/WellnessFull.jpg?v=1767582879&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Wellness1.jpg?v=1767582878&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Wellness2.jpg?v=1767582878&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Wellness3.jpg?v=1767582879&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Wellness4.jpg?v=1767582879&width=2048"
    ],
    "preview": "https://shop.minimaldesksetups.com/cdn/shop/files/WellnessFull.jpg?v=1767582879&width=700",
    "zoom": "https://shop.minimaldesksetups.com/cdn/shop/files/WellnessFull.jpg?v=1767582879&width=2048",
    "isNew": true,
    "priceCentsAU": 1399,
    "variantTitleMatch": "Wellness Tracker (",
    "variantIds": [
      49882470154433
    ],
    "catalogTitle": "Wellness Tracker (60 Pages)"
  },
  "daily": {
    "title": "Daily",
    "line": "A full page each day to plan, focus and reflect.",
    "included": [
      "A5 - 100GSM Dutch White Paper",
      "60 pages (enough for 2-3 month)",
      "Set your priority, list your tasks and timeblock your day"
    ],
    "bestFor": [
      "Anyone who wants structure in their day, with an emphasis on deep work through timeblocking."
    ],
    "howTo": [
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/daily1_09b222fe-6335-401d-bbd7-00a4d9b5d43e.jpg?v=1758800383&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/daily1_09b222fe-6335-401d-bbd7-00a4d9b5d43e.jpg?v=1758800383&width=2048",
        "title": "Step 1: Prioritise",
        "lead": "Choose your most important task of the day and write it under “Priority”",
        "body": "This follows the “Eat the Frog Method”, which helps you prioritize and tackle your most important task first."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/daily2_41c9ae11-2690-48e1-b4b0-b6fa069750f9.jpg?v=1758800511&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/daily2_41c9ae11-2690-48e1-b4b0-b6fa069750f9.jpg?v=1758800511&width=2048",
        "title": "Step 2:  Capture",
        "lead": "Write down every task, idea, and reminder that’s on your mind.",
        "body": "This clears mental clutter and gives you a complete picture on what requires your attention."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/daily3_e09efdd4-32a1-48e7-8bd6-e6d580d1dba3.jpg?v=1758800386&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/daily3_e09efdd4-32a1-48e7-8bd6-e6d580d1dba3.jpg?v=1758800386&width=2048",
        "title": "Step 3: Time Block",
        "lead": "Assign each task to a specific time slot in your day.",
        "body": "This helps you visualize your available time, create a realistic schedule, helping you stay on track."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/daily4_948c0981-d6bc-48ae-8938-dc63a79f6546.jpg?v=1758800385&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/daily4_948c0981-d6bc-48ae-8938-dc63a79f6546.jpg?v=1758800385&width=2048",
        "title": "Step 4: Tomorrow",
        "lead": "Before you finish for the day, plan out tomorrow’s top tasks.",
        "body": "This sets you up for a stress-free start and keeps your momentum going."
      }
    ],
    "howToPages": "60 Pages",
    "pages": "60 Pages",
    "images": [
      "https://shop.minimaldesksetups.com/cdn/shop/files/DailyFull.jpg?v=1758799818&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/daily1_09b222fe-6335-401d-bbd7-00a4d9b5d43e.jpg?v=1758800383&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/daily2_41c9ae11-2690-48e1-b4b0-b6fa069750f9.jpg?v=1758800511&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/daily3_e09efdd4-32a1-48e7-8bd6-e6d580d1dba3.jpg?v=1758800386&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/daily4_948c0981-d6bc-48ae-8938-dc63a79f6546.jpg?v=1758800385&width=2048"
    ],
    "preview": "https://shop.minimaldesksetups.com/cdn/shop/files/DailyFull.jpg?v=1758799818&width=700",
    "zoom": "https://shop.minimaldesksetups.com/cdn/shop/files/DailyFull.jpg?v=1758799818&width=2048",
    "isNew": false,
    "priceCentsAU": 1399,
    "variantTitleMatch": "Daily (",
    "variantIds": [
      48909976142017
    ],
    "catalogTitle": "Daily (60 Pages)"
  },
  "weekly": {
    "title": "Weekly",
    "line": "See your whole week at a glance and plan each day.",
    "included": [
      "A5 - 100GSM Dutch White Paper",
      "30 pages",
      "Monday - Sunday spread",
      "Dedicated notes page per week"
    ],
    "bestFor": [
      "For anyone who wants to map out every day of their week and see it all in one view."
    ],
    "howTo": [
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/week1_9d831ed6-f90a-490a-9d0e-5460206f7e4d.jpg?v=1758859656&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/week1_9d831ed6-f90a-490a-9d0e-5460206f7e4d.jpg?v=1758859656&width=2048",
        "title": "Step 1: Capture",
        "lead": "Write down all your tasks, deadlines, and events for each day.",
        "body": "This gives you a full snapshot of your week, so you know what’s coming up."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/week2.jpg?v=1758859656&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/week2.jpg?v=1758859656&width=2048",
        "title": "Step 2: Add Events",
        "lead": "Block in important meetings, appointments, and time-specific commitments.",
        "body": "Seeing these in your plan helps you schedule tasks around them."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/week3.jpg?v=1758859656&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/week3.jpg?v=1758859656&width=2048",
        "title": "Step 3: Memo",
        "lead": "Use the memo section to jot down notes, ideas, or weekly reflections.",
        "body": "This space allows you to track progress, capture insights, and stay intentional."
      }
    ],
    "howToPages": "30 Pages",
    "pages": "30 Pages",
    "images": [
      "https://shop.minimaldesksetups.com/cdn/shop/files/WeekFull.jpg?v=1758859657&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/week1_9d831ed6-f90a-490a-9d0e-5460206f7e4d.jpg?v=1758859656&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/week2.jpg?v=1758859656&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/week3.jpg?v=1758859656&width=2048"
    ],
    "preview": "https://shop.minimaldesksetups.com/cdn/shop/files/WeekFull.jpg?v=1758859657&width=700",
    "zoom": "https://shop.minimaldesksetups.com/cdn/shop/files/WeekFull.jpg?v=1758859657&width=2048",
    "isNew": false,
    "priceCentsAU": 1199,
    "variantTitleMatch": "Weekly (",
    "variantIds": [
      48909976174785
    ],
    "catalogTitle": "Weekly (30 Pages)"
  },
  "monthly": {
    "title": "Monthly",
    "line": "View each month on two page spreads to map deadlines, trips and bigger plans.",
    "included": [
      "A5 - 100GSM Dutch White Paper",
      "15 Pages (enough for whole year and more)",
      "Extra notes column right side"
    ],
    "bestFor": [
      "monthly planing to see the bigger picture."
    ],
    "howTo": [
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Month1.jpg?v=1758859772&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Month1.jpg?v=1758859772&width=2048",
        "title": "Step 1: Map",
        "lead": "Fill in key dates, deadlines, events, and goals across the calendar.",
        "body": "This gives you a clear overview of the entire month so you can plan ahead with confidence."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Month2.jpg?v=1758859773&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Month2.jpg?v=1758859773&width=2048",
        "title": "Step 2: Memo",
        "lead": "Write monthly priorities, reminders, or notes in the memo section.",
        "body": "This space allows you to track progress, capture insights, and stay intentional."
      }
    ],
    "howToPages": "15 Pages",
    "pages": "15 Pages",
    "images": [
      "https://shop.minimaldesksetups.com/cdn/shop/files/MonthFull.jpg?v=1758859773&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Month1.jpg?v=1758859772&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Month2.jpg?v=1758859773&width=2048"
    ],
    "preview": "https://shop.minimaldesksetups.com/cdn/shop/files/MonthFull.jpg?v=1758859773&width=700",
    "zoom": "https://shop.minimaldesksetups.com/cdn/shop/files/MonthFull.jpg?v=1758859773&width=2048",
    "isNew": false,
    "priceCentsAU": 1199,
    "variantTitleMatch": "Monthly (",
    "variantIds": [
      48909976207553
    ],
    "catalogTitle": "Monthly (15 Pages)"
  },
  "to-do": {
    "title": "To-Do",
    "line": "Simple lists to capture tasks and tick them off.",
    "included": [
      "A5 - 100GSM Dutch White Paper",
      "60 pages"
    ],
    "bestFor": [
      "Anyone who needs a versatile list for to-dos, recipes, etc. Also ideal for braindumping tasks."
    ],
    "howTo": [
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Todo1.jpg?v=1758859849&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Todo1.jpg?v=1758859849&width=2048",
        "title": "Step 1: List",
        "lead": "Use the left column to write down everything you need to do, deadlines, and reminders.",
        "body": "This helps you stay organized and see all your priorities in one place."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Todo2.jpg?v=1758859849&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Todo2.jpg?v=1758859849&width=2048",
        "title": "Step 2: Memo",
        "lead": "Use the memo section to capture notes, ideas, or additional details related to your tasks.",
        "body": "This keeps everything connected and easy to reference while you work."
      }
    ],
    "howToPages": "60 Pages",
    "pages": "60 Pages",
    "images": [
      "https://shop.minimaldesksetups.com/cdn/shop/files/TodoFull.jpg?v=1758859850&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Todo1.jpg?v=1758859849&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Todo2.jpg?v=1758859849&width=2048"
    ],
    "preview": "https://shop.minimaldesksetups.com/cdn/shop/files/TodoFull.jpg?v=1758859850&width=700",
    "zoom": "https://shop.minimaldesksetups.com/cdn/shop/files/TodoFull.jpg?v=1758859850&width=2048",
    "isNew": false,
    "priceCentsAU": 1399,
    "variantTitleMatch": "To-Do (",
    "variantIds": [
      48909976240321
    ],
    "catalogTitle": "To-Do (60 Pages)"
  },
  "memo": {
    "title": "Memo",
    "line": "Quick memo pages for notes, ideas and small reminders.",
    "included": [
      "A5 - 100GSM Dutch White Paper",
      "60 pages",
      "5mm dotted grid"
    ],
    "bestFor": [
      "Anyone who needs a dedicated memo layout."
    ],
    "howTo": [
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Memo1.jpg?v=1758860060&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Memo1.jpg?v=1758860060&width=2048",
        "title": "Capture Ideas",
        "lead": "Jot down thoughts, brainstorm ideas, or mind maps.",
        "body": "The dot grid gives you structure while keeping things flexible and free-flowing."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Memo2.jpg?v=1758860060&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Memo2.jpg?v=1758860060&width=2048",
        "title": "Sketch & Doodle",
        "lead": "Use the grid for quick drawings, wireframes, or layouts.",
        "body": "Perfect for visual thinkers who like to map things out on paper."
      }
    ],
    "howToPages": "60 Pages",
    "pages": "60 Pages",
    "images": [
      "https://shop.minimaldesksetups.com/cdn/shop/files/MemoFull.jpg?v=1758860060&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Memo1.jpg?v=1758860060&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Memo2.jpg?v=1758860060&width=2048"
    ],
    "preview": "https://shop.minimaldesksetups.com/cdn/shop/files/MemoFull.jpg?v=1758860060&width=700",
    "zoom": "https://shop.minimaldesksetups.com/cdn/shop/files/MemoFull.jpg?v=1758860060&width=2048",
    "isNew": false,
    "priceCentsAU": 1399,
    "variantTitleMatch": "Memo (",
    "variantIds": [
      48909976305857
    ],
    "catalogTitle": "Memo (60 Pages)"
  },
  "habit-tracker": {
    "title": "Habit Tracker",
    "line": "Turn habits into routine by tracking habits daily.",
    "included": [
      "Half Width A5 - 150 GSM Card",
      "15 Cards (enough for a whole year)",
      "Track habits daily with a notes section below"
    ],
    "bestFor": [
      "Anyone looking to build long term habits."
    ],
    "howTo": [
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Habit1_1bde5b08-ed53-47ba-89b4-5783359f64f5.jpg?v=1758859939&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Habit1_1bde5b08-ed53-47ba-89b4-5783359f64f5.jpg?v=1758859939&width=2048",
        "title": "Step 1: List",
        "lead": "Write down the habits you want to build or track for the month.",
        "body": "This sets a clear focus and helps you stay consistent on what matters most."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Habit2.jpg?v=1758859939&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Habit2.jpg?v=1758859939&width=2048",
        "title": "Step 2: Track",
        "lead": "Record your progress by checking off each day.",
        "body": "This gives you a visual record of your streaks and keeps you motivated to stay on track."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Habit3A.jpg?v=1759127370&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Habit3A.jpg?v=1759127370&width=2048",
        "title": "Step 3: Tally",
        "lead": "At month’s end, count how many days you completed each habit.",
        "body": "Monthly total will shows you if the habit’s actually sticking, keeping you motivated for next month."
      },
      {
        "image": "https://shop.minimaldesksetups.com/cdn/shop/files/Habit3.jpg?v=1758859939&width=760",
        "full": "https://shop.minimaldesksetups.com/cdn/shop/files/Habit3.jpg?v=1758859939&width=2048",
        "title": "Step 4: Memo",
        "lead": "Keep track of reflections, and notes in the memo area.",
        "body": "This helps you see patterns, celebrate wins, and make improvements for next month."
      }
    ],
    "howToPages": "15 Cards",
    "pages": "15 Cards",
    "images": [
      "https://shop.minimaldesksetups.com/cdn/shop/files/HabitFull_06d80f60-a1ea-43df-ab9a-bebe5bd63b1c.jpg?v=1758859979&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Habit1_1bde5b08-ed53-47ba-89b4-5783359f64f5.jpg?v=1758859939&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Habit2.jpg?v=1758859939&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Habit3A.jpg?v=1759127370&width=2048",
      "https://shop.minimaldesksetups.com/cdn/shop/files/Habit3.jpg?v=1758859939&width=2048"
    ],
    "preview": "https://shop.minimaldesksetups.com/cdn/shop/files/HabitFull_06d80f60-a1ea-43df-ab9a-bebe5bd63b1c.jpg?v=1758859979&width=700",
    "zoom": "https://shop.minimaldesksetups.com/cdn/shop/files/HabitFull_06d80f60-a1ea-43df-ab9a-bebe5bd63b1c.jpg?v=1758859979&width=2048",
    "isNew": false,
    "priceCentsAU": 1399,
    "variantTitleMatch": "Habit Tracker (",
    "variantIds": [
      48909976273089
    ],
    "catalogTitle": "Habit Tracker (15 Cards)"
  },
  "2027-set": {
    "title": "2027 Set",
    "line": "A full dated year including a yearly, monthly and weekly spreads.",
    "included": [
      "A5 - 100GSM Dutch White Paper",
      "Yearly Calendar",
      "Monthly Spread",
      "Dated Weekly Layout"
    ],
    "bestFor": [
      "Anyone who wants their entire 2027 already set up ready to go."
    ],
    "howTo": [],
    "howToPages": "",
    "pages": "",
    "images": [
      "https://shop.minimaldesksetups.com/cdn/shop/files/2027Full.jpg?v=1792070767&width=2048"
    ],
    "preview": "https://shop.minimaldesksetups.com/cdn/shop/files/2027Full.jpg?v=1792070767&width=700",
    "zoom": "https://shop.minimaldesksetups.com/cdn/shop/files/2027Full.jpg?v=1792070767&width=2048",
    "isNew": true,
    "priceCentsAU": 2999,
    "variantTitleMatch": "2027 Set",
    "variantIds": [
      50749968318657
    ],
    "catalogTitle": "2027 Set"
  }
};
